module.exports = __webpack_public_path__ + "img/ic_hotel_name_white.c717d582.svg";